import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';

const gridCols = responsive({
  0: 'repeat(1, 1fr)',
  3: 'repeat(2, 1fr)',
  5: 'repeat(4, 1fr)',
});

const spanAll = responsive({
  0: 'span 1',
  3: 'span 2',
  5: 'span 4',
});

const spanHalf = responsive({
  0: 'span 1',
  5: 'span 2',
});

const orgUnit: ThemeUICSSObject = {
  upsertion: {
    fieldset: {
      display: 'grid',
      gridTemplateColumns: gridCols,
      gap: spacing(4),
      p: spacing(7),
      border: 'none',
      ...getColorsByPath('tab'),

      '.fldSpanAll': {
        gridColumn: spanAll,
      },

      '.fldSpanHalf': {
        gridColumn: spanHalf,
      },

      '& label': {
        alignItems: 'stretch',
      },

      '.organizationalUnit__users, .organizationalUnit__roles': {
        gridColumn: spanAll,
        '.organizationalUnit__wrapper': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          gap: spacing(3),
          fontWeight: 'bold',
          '.organizationalUnit__boxlist': {
            width: '100%',
            maxHeight: responsive({ 0: '50vh', 3: '30vh' }),
            overflow: 'auto',
            display: 'grid',
            gap: spacing(3),
            pr: spacing(3),
            fontWeight: 'normal',
            gridTemplateColumns: responsive({
              0: 'repeat(1, 1fr)',
              3: 'repeat(2, 1fr)',
              5: 'repeat(3, 1fr)',
              6: 'repeat(4, 1fr)',
            }),
            '.labelBox': {
              span: {
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
              '.closeButton': {
                minWidth: '24px',
                '&:disabled': {
                  backgroundColor: 'transparent',
                  opacity: 0.25,
                },
              },
            },
          },
        },
      },
    },
  },
};

export default orgUnit;
